var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 14.25H13.125",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49998 5.7373H2.5C2.15625 5.7373 1.875 6.01855 1.875 6.3623V11.7498C1.875 12.0936 2.15625 12.3748 2.5 12.3748H3.49998C3.84373 12.3748 4.12498 12.0936 4.12498 11.7498V6.3623C4.12498 6.01855 3.84373 5.7373 3.49998 5.7373Z",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 3.74365H7C6.65625 3.74365 6.375 4.0249 6.375 4.36865V11.7499C6.375 12.0937 6.65625 12.3749 7 12.3749H7.99998C8.34373 12.3749 8.62498 12.0937 8.62498 11.7499V4.36865C8.62498 4.0249 8.34373 3.74365 7.99998 3.74365Z",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.75H11.5C11.1562 1.75 10.875 2.03125 10.875 2.375V11.75C10.875 12.0938 11.1562 12.375 11.5 12.375H12.5C12.8437 12.375 13.125 12.0938 13.125 11.75V2.375C13.125 2.03125 12.8437 1.75 12.5 1.75Z",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFees);
export default __webpack_public_path__ + "static/media/fees.2fb464b7baef34e8cfc594b026da54f2.svg";
export { ForwardRef as ReactComponent };